export default __webpack_public_path__ + "static/media/Logo_Small_Transparent.1d863693.png";